import { ModuleBase, Media, Stack, HeadingTag } from '@/components';
import { isColorDark, fixColor } from '@/utils';
import classNames from 'classnames';

const BannerFullBleedModule = ({ data }) => {
  const { headingTitle, backgroundMedia, disableInset, headingStyle, bannerHeight } = data || {};

  const darkBg = isColorDark(fixColor(data.backgroundColour));
  const isOverlay = headingStyle?.toLowerCase() === 'overlay';
  const isSlim = bannerHeight?.toLowerCase() === 'slim';

  return (
    <ModuleBase data={data}>
      <Stack
        className={classNames(
          'relative overflow-hidden',
          disableInset ? 'p-0' : 'px-6 pb-8 pt-6 md:px-10 lg:pb-10 lg:pt-10',
        )}
      >
        <div
          className={classNames(
            'relative w-full',
            isSlim
              ? 'h-[194px] md:h-[424px] lg:h-[50vh] lg:min-h-[465px]'
              : 'h-[194px] md:h-[424px] lg:h-[80vh] lg:min-h-[765px]',
          )}
        >
          <Media
            media={backgroundMedia}
            widths={{ xs: 345, md: 1024, lg: 1440, xl: 1900 }}
            cover={
              backgroundMedia.autoPlay ||
              (!backgroundMedia.autoPlay &&
                !backgroundMedia.vimeoId &&
                !backgroundMedia.mobileVimeoId &&
                !backgroundMedia.youtubeId)
            }
            background={data.backgroundMedia.autoPlay}
          />

          {/* Overlay heading: flex-centered over the media */}
          {isOverlay && headingTitle?.heading && (
            <div className="absolute inset-0 z-10 flex items-center justify-center px-6">
              <div className="pointer-events-none absolute inset-0 bg-black/15" aria-hidden="true" />
              <HeadingTag
                animate
                data={headingTitle}
                className="relative z-10 max-w-[900px] text-center font-larken text-mobile-large font-normal not-italic leading-[1.1] text-white [text-shadow:0_2px_10px_rgba(0,0,0,0.5)] sm:text-desktop-large"
              />
            </div>
          )}
        </div>

        {/* Caption heading: bold text below the image */}
        {!isOverlay && headingTitle?.heading && (
          <HeadingTag
            animate
            data={headingTitle}
            className={classNames(
              'my-4 text-center font-gotham text-xs font-n-light leading-tiny-paragraph',
              darkBg ? 'text-white' : 'text-black',
            )}
          />
        )}
      </Stack>
    </ModuleBase>
  );
};

export default BannerFullBleedModule;
